<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red" style="background-color: #efd094 !important;height:4rem;">
        <div class="headerCon acea-row row-between-wrapper" >
          <div style="margin-top:-2rem;">
            <div class="name">我的团队</div>
            <!--<div>
              <span class="num" style="font-size:0.3rem;">直推：{{ first }}</span>人
            </div>
            <div>
              <span class="num" style="font-size:0.3rem;">团队：{{allCount}}</span>人
            </div>-->
          </div >
          <div class="iconfont icon-tuandui" style="margin-top:-2rem;"></div>
        </div>
      </div>
      <!--<div class="nav acea-row row-around">
        <div
          class="item"
          :class="screen.grade == 0 ? 'on' : ''"
          @click="checkGrade(0)"
        >
          一级
        </div>
        <div
          class="item"
          :class="screen.grade == 1 ? 'on' : ''"
          @click="checkGrade(1)"
        >
          二级
        </div>
      </div>-->
      <div style="height: 1.2rem;
    margin: -1.7rem auto 0px;
    width: 7rem;
    background-color: rgb(74, 62, 44);
    border-radius: 0.2rem 0.2rem 0px 0px;
        color: rgb(227, 213, 174);">
            <span class="num" style="height:1.1rem;line-height:1.1rem;font-size:0.3rem;width:50%;display:block;float:left;text-align:center;padding:0.1rem 0rem;" >
              <span style="height:0.1rem;display:block;">团队：{{allCount}}人</span>

            </span>

        <span style="clear:both;"></span>
      </div>
      <div style="background-color:#fff;height:1.2rem;width:7.2rem;margin:0 auto;border-radius: 0.06rem;" v-if="levelCountCount">
          <span class="num" style="height:1.1rem;border:1px solid #f1f1f1;font-size:0.3rem;width:20%;display:block;float:left;text-align:center;padding:0.1rem 0rem;" v-for="(item, index) in levelCount" :key="index">
            <span style="height:0.1rem;display:block;">{{index}}</span><br />{{item}}人
          </span>
        <span style="clear:both;"></span>
      </div>
      <div class="search acea-row row-between-wrapper" style="margin-top:0.2rem;">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="会员号/手机号" v-model="screen.keyword" />
            <span class="iconfont icon-guanbi"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2" @click="submitForm"></div>
      </div>
    </div>
    <div class="list">
      <!--<div
        class="sortNav acea-row row-middle"
        :class="fixedState === true ? 'on' : ''"
      >
        <div class="sortItem" @click="sort('childCount')">
          团队排序
          <img src="@assets/images/sort1.png" v-if="childCount == 1" />
          <img src="@assets/images/sort2.png" v-if="childCount == 2" />
          <img src="@assets/images/sort3.png" v-if="childCount == 3" />
        </div>
        <div class="sortItem" @click="sort('numberCount')">
          金额排序
          <img src="@assets/images/sort1.png" v-if="numberCount == 1" />
          <img src="@assets/images/sort2.png" v-if="numberCount == 2" />
          <img src="@assets/images/sort3.png" v-if="numberCount == 3" />
        </div>
        <div class="sortItem" @click="sort('orderCount')">
          订单排序
          <img src="@assets/images/sort1.png" v-if="orderCount == 1" />
          <img src="@assets/images/sort2.png" v-if="orderCount == 2" />
          <img src="@assets/images/sort3.png" v-if="orderCount == 3" />
        </div>
      </div>-->
      <div :class="fixedState === true ? 'sortList' : ''">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(val, index) in networkList"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="val.avatar" /></div>
            <div class="text">
                <div class="name line1"></div>
              <div class="name line1"><span style="color:red;">【{{ val.area_name }}】</span><span v-if="val.level_name">（{{ val.level_name }}）</span></div>
                <div class="name line1">{{ val.account }} {{ val.nickname }}</div>
                <!--<div class="name line1">{{ val.phone }}</div>-->
              <!--<div class="name line1">直推：{{ val.network_count }}人</div>-->
              <div class="name line1"  v-if="val.level_name">团队：{{ val.network_all }}人</div>
              <div> {{ val.add_time }}</div>
                <div>
                  <span v-if="val.is_can_prev_look ==1" style="width:50%;" class="show_layer can_show_layer" @click="prevNextLayer(val.prev_parent_uid)">上一代</span>
                  <!--<span v-if="val.is_can_prev_look ==0" class="show_layer" >上一代</span>-->

                  <span v-if="val.is_can_next_look ==1"  style="width:50%;" class="show_layer can_show_layer" @click="prevNextLayer(val.uid)">下一代</span>
                  <!--<span v-if="val.is_can_next_look ==0" class="show_layer">下一代</span>-->

                  <span v-if="val.is_can_network ==1"  style="width:50%;" class="show_layer can_show_layer" @click="$router.push({ path: '/user/register/0/'+val.network_phone+'/'+val.area })">注册</span>

                </div>
            </div>
          </div>
          <!--<div class="right">
            <div>
              <span class="font-color-red">{{ val.childCount }}</span> 人
            </div>
            <div>{{ val.orderCount }} 单</div>
            <div>{{ val.numberCount ? val.numberCount : 0 }} 元</div>
          </div>-->
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .promoter-list .list .item{
    height:auto;
    padding-bottom:0.2rem;
    padding-top:0.2rem;
  }
  .show_layer {
    text-align: center;
    border: 1px solid #f1f1f1;
    margin-top: 0.2rem;
    line-height: 0.6rem;
    color: #999;
    font-size: 0.2rem;
    width:50%;
    float:left;
  }
  .can_show_layer {
    color:#000;
  }
</style>
<script>
import {deleteClass, getNetworkUser} from "../../../api/user";
import Loading from "@components/Loading";
import dialog from "@utils/dialog";
export default {
  name: "PromoterList",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      screen: {
        page: 1,
        limit: 15,
        grade: 0,
          network_uid:0,
        keyword: "",
        sort: ""
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      networkList: [],
      levelCount:[],
      levelCountCount:0,
      allCount:0,
      loadTitle: "",
      first: "",
      second: ""
    };
  },
  mounted: function() {
    this.getNetworkUsers();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getNetworkUsers();
    });
  },
  watch: {
    "screen.sort": function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.networkList = [];
      this.getNetworkUsers();
    }
  },
  methods: {
    handleScroll: function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    submitForm: function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.networkList = [];
      this.getNetworkUsers();
    },
      prevNextLayer: function(network_uid) {
          this.screen.page = 0;
          this.screen.network_uid = network_uid;
          this.loaded = false;
          this.loading = false;
          this.networkList = [];
          this.getNetworkUsers();
      },
    getNetworkUsers: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getNetworkUser(screen).then(
        res => {
          that.loading = false;
          that.networkList.push.apply(that.networkList, res.data.list);
          that.levelCount = res.data.levelCount;
          that.levelCountCount = res.data.levelCountCount;
          that.loaded = res.data.list.length < that.screen.limit; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.screen.page = that.screen.page + 1;
          that.first = res.data.total;
          that.allCount = res.data.allCount;
          that.second = res.data.totalLevel;
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    checkGrade: function(val) {
      if (val == this.screen.grade) return;
      else {
        this.screen.page = 1;
        this.screen.grade = val;
        this.loading = false;
        this.loaded = false;
        this.networkList = [];
        this.getNetworkUsers();
      }
    },
    sort: function(types) {
      let that = this;
      switch (types) {
        case "childCount":
          if (that.childCount == 2) {
            that.childCount = 1;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount DESC";
          } else if (that.childCount == 1) {
            that.childCount = 3;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "childCount ASC";
          } else if (that.childCount == 3) {
            that.childCount = 2;
            that.orderCount = 2;
            that.numberCount = 2;
            that.screen.sort = "";
          }
          break;
        case "numberCount":
          if (that.numberCount == 2) {
            that.numberCount = 1;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount DESC";
          } else if (that.numberCount == 1) {
            that.numberCount = 3;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "numberCount ASC";
          } else if (that.numberCount == 3) {
            that.numberCount = 2;
            that.orderCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        case "orderCount":
          if (that.orderCount == 2) {
            that.orderCount = 1;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount DESC";
          } else if (that.orderCount == 1) {
            that.orderCount = 3;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "orderCount ASC";
          } else if (that.orderCount == 3) {
            that.orderCount = 2;
            that.numberCount = 2;
            that.childCount = 2;
            that.screen.sort = "";
          }
          break;
        default:
          that.screen.sort = "";
      }
    }
  }
};
</script>
